module.exports = __webpack_public_path__ + "img/14_28.6d5ee83a.png";